export default "__VITE_ASSET__CRI1QTy1__"